import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff'
import StoreIcon from '@mui/icons-material/Store'
import AmazonSvg from '../../images/icons/amazon.svg'
import { default as GroMicrosoftIcon, default as MicrosoftSvg } from '../../images/icons/bing.png'
import BudgetSvg from '../../images/icons/budget.svg'
import GroConsultingIcon from '../../images/icons/Consulting.png'
import GroCreativeIcon from '../../images/icons/Creative.png'
import DarkBudgetSvg from '../../images/icons/darkBudget.svg'
import ElementorSvg from '../../images/icons/elementor.svg'
import QuestionMarkIcon from '../../images/icons/favicon-16x16.png'
import { default as GoogleSearchSvg, default as GroGoogleIcon } from '../../images/icons/Google Ads.png'
import { default as GoogleDisplaySvg, default as GroGoogleDisplayIcon } from '../../images/icons/Google Display.png'
import GoogleSearchIcon from '../../images/icons/google-search-icon.svg'
import { default as LinkedinIcon, default as LinkedInSvg } from '../../images/icons/linkedin.svg'
import LoopAnalyticsLogo from '../../images/icons/loop_logo_knockout.png'
import GroMetaIcon from '../../images/icons/meta.png'
import MetaLightSvg from '../../images/icons/meta_1.svg'
import GroPhotographyIcon from '../../images/icons/Photography.png'
import RedditPng from '../../images/icons/reddit-icon.png'
import RedditSvg from '../../images/icons/reddit-logo-2436.svg'
import GroSeoTierCustomIcon from '../../images/icons/SEO - Custom.png'
import Seo2Svg from '../../images/icons/seotier2.svg'
import SimplifiSvg from '../../images/icons/simplifi_logo.svg'
import { default as SnapchatSvg, default as SnapChatSvg } from '../../images/icons/snapchat.svg'
import GroSpotifyIcon from '../../images/icons/spotify.png'
import SpotifySvg from '../../images/icons/spotify.svg'
import { default as GroTikTokIcon, default as TikTokSvg } from '../../images/icons/tik-tok.png'
import GroVideographyIcon from '../../images/icons/Videography.png'
import GroWebsiteHostingIcon from '../../images/icons/Website Hosting.png'
import GroYouTubeIcon from '../../images/icons/youtube.png'
import { default as YouTubeIcon, default as YoutubeSvg } from '../../images/icons/youtube.svg'

const PRODUCT_ICON_MAP: Record<string, any> = {
  // --- from getProductIcon (preferred on duplicates) ---
  'Paid Search Advertising': GroGoogleIcon,
  'Google Display Advertising': GroGoogleDisplayIcon,
  'Meta Advertising': GroMetaIcon,
  'YouTube Advertising': GroYouTubeIcon,
  'Amazon Advertising': AmazonSvg,
  'SnapChat Advertising': SnapChatSvg,
  'TikTok Advertising': GroTikTokIcon,
  'Reddit Advertising': RedditPng,

  'Website Hosting': GroWebsiteHostingIcon,
  'Website Hosting + 30 Minutes of Maintenance': GroWebsiteHostingIcon,
  'Website Hosting + 60 Minutes of Maintenance': GroWebsiteHostingIcon,

  'Website Revisions': ElementorSvg,

  'SEO - Tier 1': Seo2Svg,
  'SEO - Tier 2': Seo2Svg,
  'SEO - Tier 3': Seo2Svg,
  'SEO - Tier 4': GroSeoTierCustomIcon,

  'Spotify Advertising': GroSpotifyIcon,
  'Microsoft Advertising': GroMicrosoftIcon,

  'Graphic Design - General': GroCreativeIcon,
  'Graphic Design - Logo Creation': GroCreativeIcon,
  'Graphic Design - Additional Logo Revisions': GroCreativeIcon,
  'Graphic Design - Revisions': GroCreativeIcon,

  'Creative Services - Hourly': HistoryToggleOffIcon,
  'Marketing Collateral': StoreIcon,
  'Business Systems Kit': StoreIcon,
  'Design Materials': GroCreativeIcon,
  'Agency Retainer - Creative': GroCreativeIcon,
  'Branding Guide': GroCreativeIcon,
  'Travel, Lodging, Misc.': GroCreativeIcon,

  'Video Shoot': GroVideographyIcon,
  'Video Editing': GroVideographyIcon,
  'Lifestyle Video Shoot': GroVideographyIcon,
  'Drone Shoot - Add On': GroVideographyIcon,
  'Photo Shoot': GroPhotographyIcon,
  'Photo Editing': GroPhotographyIcon,
  'Add On - Generative Engine Optimization': GoogleSearchIcon,
  Consulting: GroConsultingIcon,

  // note: these are *different strings* than the "YouTube Advertising" ones above
  'Youtube Advertising': YouTubeIcon,
  'Linkedin Advertising': LinkedinIcon,

  'Programmatic Display Advertising': SimplifiSvg,
  'Programmatic Video Advertising': SimplifiSvg,
  'Programmatic Audio Advertising': SimplifiSvg,

  'Standard Website Build': ElementorSvg,

  // --- service-only entries (weren’t in getProductIcon) ---
  'Simplifi Advertising': SimplifiSvg,
  'Paid Search - Media Spend': BudgetSvg,
  'Projected Budget': DarkBudgetSvg,
  'Full Brand Build': GroCreativeIcon,
  'Loop Core': LoopAnalyticsLogo,
  'Loop CallRail Integration': LoopAnalyticsLogo,
  'Loop Setup': LoopAnalyticsLogo,
  'Loop Advanced': LoopAnalyticsLogo,
}

// 2) Both functions now reuse the same source of truth.

export const getProductIcon = (productName: string) => {
  return PRODUCT_ICON_MAP[productName] ?? QuestionMarkIcon
}

const SERVICE_ICON_FALLBACK_MAP: Record<string, any> = {
  'Paid Search Advertising': GoogleSearchSvg,
  'Google Display Advertising': GoogleDisplaySvg,
  'Meta Advertising': MetaLightSvg,
  'Microsoft Advertising': MicrosoftSvg,
  'SEO - Tier 1': GoogleSearchIcon,
  'SEO - Tier 2': GoogleSearchIcon,
  'SEO - Tier 3': GoogleSearchIcon,
  'SEO - Tier 4': GoogleSearchIcon,
  'Add On - Generative Engine Optimization': GoogleSearchIcon,
  'SnapChat Advertising': SnapchatSvg,
  'Spotify Advertising': SpotifySvg,
  'TikTok Advertising': TikTokSvg,
  'Linkedin Advertising': LinkedInSvg,
  'Youtube Advertising': YoutubeSvg,
  'Reddit Advertising': RedditSvg,
}

export const renderServiceIcon = (productName: string) => {
  return PRODUCT_ICON_MAP[productName] ?? SERVICE_ICON_FALLBACK_MAP[productName] ?? QuestionMarkIcon
}
